(() => {
  if (window.tapputiProductInitialized) return;
  window.tapputiProductInitialized = true;
  document.addEventListener('click', (event) => {
    const launch = event.target.closest('[data-tapputi-video]');
    if (launch) {
      const dialog = document.getElementById(launch.dataset.tapputiVideo);
      if (!dialog) return;
      dialog.showModal();
      dialog.querySelector('video')?.play().catch(() => {});
      dialog.addEventListener('close', () => {
        dialog.querySelector('video')?.pause();
        launch.focus();
      }, { once: true });
    }
    const close = event.target.closest('.tapputi-video-close');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.tapputi-video-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  const connect = () => {
    if (!window.MinimogEvents || !window.MinimogTheme) return;
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, ({ data }) => {
      const destination = document.getElementById(`TapputiPaymentDetails-${data.sectionId}`);
      const source = data.html?.getElementById(`TapputiPaymentDetails-${data.sectionId}`);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
